var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.759 34.6232V28.284C23.759 27.4652 23.3391 25.7197 22.4388 25.0687C28.6928 24.4232 31.1901 21.1729 31.0994 15.5255C31.0994 13.7701 30.5679 12.1846 29.1739 10.5811C29.7539 8.75716 29.6393 7.5759 28.9661 5.55933C27.8492 5.43811 26.5839 5.70264 23.7626 7.49881C20.3599 6.68494 17.7182 6.61979 14.2452 7.50352C11.424 5.70735 10.0799 5.39383 9.00473 5.5632C8.33159 7.57977 8.24686 8.77436 8.82683 10.5983C7.4329 12.2018 6.86846 13.8179 6.86846 15.5734C6.98097 21.4166 9.43866 24.2846 15.5361 25.0687C14.6358 25.7197 14.2158 27.4652 14.2158 28.284V28.9808M14.2158 34.6232V28.9808M5.05194 24.3064C5.92666 24.5289 7.86902 25.7005 9.16063 27.8795C10.4056 29.98 12.5645 29.8034 14.2158 28.9808",
    stroke: "#5F6B98",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.1169a6532a53f5501498b8078f33d276.svg";
export { ForwardRef as ReactComponent };